import React, { useState } from 'react';
import styles from './offer-dropdown.module.scss';
import { IOfferDropdownProps } from './offer-dropdown.interface';
import { Triangle } from '../triangle/triangle';

export const OfferDropdown: React.FC<IOfferDropdownProps> = ({
  title,
  description,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div
      className={styles.offer_dropdown}
      onClick={() => setShowDropdown(!showDropdown)}
    >
      <div className={styles.offer_dropdown__title}>
        {title}
        <Triangle isRotated={showDropdown} />
      </div>
      <div
        className={`${styles.offer_dropdown__description} ${showDropdown ? styles['offer_dropdown__description--visible'] : ''}`}
      >
        {description}
      </div>
    </div>
  );
};
